import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        // UI
        this.$menuToggler = this.$('menu-toggler')[0]
        this.$modalToggler = this.$('modal-toggler')[0]
        this.events = {
            click: {
                'menu-toggler': 'toggleMenu',
                'modal-toggler': 'toggleModal'
            }
        }
    }

    init() {
        this.ModalAriaLabelOpen = this.$modalToggler.getAttribute('data-aria-open');
        this.ModalAriaLabelClose = this.$modalToggler.getAttribute('data-aria-close');

        this.MenuAriaLabelOpen = this.$menuToggler.getAttribute('data-aria-open');
        this.MenuAriaLabelClose = this.$menuToggler.getAttribute('data-aria-close');
    }

    toggleModal() {
        this.call('toggle', null, 'ModalHelp')
    }

    toggleMenu() {
        this.call('toggle', null, 'Menu')
    }

    openModal() {
        this.$modalToggler.setAttribute('aria-expanded', "true");
        this.$modalToggler.setAttribute('aria-label', this.ModalAriaLabelClose);
    }

    closeModal() {
        this.$modalToggler.setAttribute('aria-expanded', "true");
        this.$modalToggler.setAttribute('aria-label', this.ModalAriaLabelOpen);
    }

    openMenu() {
        this.$menuToggler.setAttribute('aria-expanded', "true");
        this.$menuToggler.setAttribute('aria-label', this.ModalAriaLabelClose);
    }

    closeMenu() {
        this.$menuToggler.setAttribute('aria-expanded', "false");
        this.$menuToggler.setAttribute('aria-label', this.ModalAriaLabelOpen);
    }
}
